class ConfiguracionesServicios {

    // SERVICIOS SECCION PUBLICA

    public servicoContactoConexion: string = 'http://localhost:3000/public/conexion'; //get
    //public servicoContactoEnviarMail: string = 'http://localhost:3000/public/enviarMail'; //post
    public servicoContactoEnviarMail: string = 'https://san-jeronimo-microservicios.herokuapp.com/public/enviarMail';

    // SERVICIOS SECCION PRIVADA

}

export default new ConfiguracionesServicios;